import { useDispatch, useSelector } from "react-redux";
import Company from "../models/company";
import {
  setCompanyPermissions,
  setCompanyPermissionsLoading,
} from "../redux/company-permissions/company-permissions-slice";
import { getList } from "../api/generics";
import { SUCCESS } from "../utils/constants/tags";
import { useEffect } from "react";
import { RootState } from "../store";

interface PermissionsProviderProps {
  children: React.ReactNode;
}

const PermissionsProvider: React.FunctionComponent<PermissionsProviderProps> = (
  props
) => {
  const company = useSelector((state: RootState) => state.company.data.company);

  const dispatch = useDispatch();
  const loadCompanyPermissions = async (company: Company) => {
    if (company.id === undefined) {
      return;
    }
    dispatch(setCompanyPermissionsLoading(true));

    const res = await getList<string>(
      `/company_permissions/${company.id}/`,
      0,
      0
    );

    if (res.status !== SUCCESS || res.data === undefined) {
      dispatch(setCompanyPermissions([]));
      dispatch(setCompanyPermissionsLoading(false));
      return;
    }

    dispatch(setCompanyPermissions(res.data.items));
    dispatch(setCompanyPermissionsLoading(false));
  };

  useEffect(
    () => {
      loadCompanyPermissions(company);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [company]
  );

  return <>{props.children}</>;
};

export default PermissionsProvider;
